import debug from 'debug';

const log = debug('InitializeSite');

class InitializeSite {
	constructor(element) {
		this.element = element;

		this.cookieAcceptEvent = this.cookieAcceptHandler.bind(this);

		this.initialize();
	}

	cookieAcceptHandler(event) {
		// Matomo tracking
		if (Cookiebot.consent.statistics) {
			log('Matomo cookie tracking');
			window._paq=window._paq||[];
			window._paq.push(['rememberCookieConsentGiven']);
		} else {
			log('Matomo cookie less tracking');
			window._paq=window._paq||[];
			_paq.push(['forgetCookieConsentGiven']);
		}
	}

	eventListeners() {
		window.addEventListener('CookiebotOnAccept', this.cookieAcceptEvent, false);
		window.addEventListener('CookiebotOnDecline', this.cookieAcceptEvent, false);
	}

	initialize() {
		this.eventListeners();
	}
}

export default InitializeSite;
